// Mirrors backend/src/constants/importedEventCategories.ts - keep both in
// sync by hand since the CMS and touchscreen frontend both need this list
// and neither currently fetches it from the API.
export const IMPORTED_EVENT_CATEGORIES = [
  'Markets & Fairs',
  'Music & Entertainment',
  'Food & Drink',
  'Arts & Culture',
  'Sports & Recreation',
  'Family & Kids',
  'Festivals & Seasonal',
  'Other',
];
